import React, { FC } from "react";
import { Asset, Button, MediaOptions, RichText } from "../../models";
import { ContentAlign } from "../../enums";
import { HeroStatic } from "./components/hero-static/HeroStatic";
import { HeroAnimated } from "./components/hero-animated/HeroAnimated";

type Props = {
  title: RichText;
  subtitle: RichText;
  contentAlign: ContentAlign;
  textAlign?: ContentAlign;
  button?: Button[];
  media: Asset;
  mediaOptions: MediaOptions[];
  isAnimated?: boolean;
};

export const Hero: FC<Props> = ({ isAnimated, ...props }) => {
  return isAnimated ? <HeroAnimated {...props} /> : <HeroStatic {...props} />;
};
